import { render, staticRenderFns } from "./ListadoPolizas.vue?vue&type=template&id=3fa452c3&"
import script from "./ListadoPolizas.vue?vue&type=script&lang=js&"
export * from "./ListadoPolizas.vue?vue&type=script&lang=js&"
import style0 from "./ListadoPolizas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports